import { useEffect, useMemo, useState } from 'react';
import { useAppStore } from '../../store';
import useDraw from './useDraw';
import DrawStage from './DrawStage';
import DrawAdmin from './DrawAdmin';
import { drawLayout, drawSchedule, SCENES } from './drawModel';
import './draw.css';

export default function DrawPage() {
  const user = useAppStore((s) => s.user);
  const isAdmin = user?.user_type === 'admin';
  const [search, setSearch] = useState(() => window.location.search || (window.location.hash.split('?')[1] || ''));
  const [adminOpen, setAdminOpen] = useState(true);
  const [fullscreenError, setFullscreenError] = useState('');
  const { data, online, busy, error, act } = useDraw();
  useEffect(() => { document.title = 'Жеребьёвка Dota 2 · Федерация киберспорта СКО'; return () => { document.title = 'Федерация киберспорта СКО'; }; }, []);
  const layout = drawLayout(search, window.innerWidth, window.innerHeight);
  const built = useMemo(() => {
    try { return { matches: drawSchedule(data) }; }
    catch (err) { return { matches: [], error: err.message }; }
  }, [data]);
  const setView = (view) => {
    const params = new URLSearchParams(search);
    if (view) params.set('view', view); else params.delete('view');
    const query = params.size ? `?${params}` : '';
    setSearch(query);
    window.history.replaceState(window.history.state, '', `/jerebiovka${query}`);
  };
  const fullscreen = async () => {
    try {
      if (document.fullscreenElement) await document.exitFullscreen();
      else if (document.documentElement.requestFullscreen) await document.documentElement.requestFullscreen();
      else setFullscreenError('Откройте меню браузера и включите полноэкранный режим.');
    } catch { setFullscreenError('Включите полноэкранный режим в меню браузера.'); }
  };
  const operator = isAdmin && adminOpen && !layout.clean;
  return <main className={`draw-page${layout.clean ? ' is-output' : ''}${operator ? ' has-operator' : ''}`}>
    {!layout.clean && <div className="draw-toolbar"><a href="/">← На сайт</a><span className="draw-toolbar-title">NOVA · LIVE DRAW</span><label><span className="sr-only">Вид экрана</span><select value={layout.scene || ''} onChange={(e) => setView(e.target.value)}><option value="">По команде режиссёра</option>{Object.entries(SCENES).map(([id, name]) => <option key={id} value={id}>{name}</option>)}</select></label><button onClick={fullscreen}>Полный экран ⛶</button>{isAdmin && <button aria-pressed={adminOpen} onClick={() => setAdminOpen(!adminOpen)}>Пульт</button>}</div>}
    {fullscreenError && <p role="status" className="draw-fullscreen-error">{fullscreenError}</p>}
    <div className="draw-workspace">
      {data ? <DrawStage data={data} online={online} matches={built.matches} search={search} /> : <div className="draw-loading" role="status"><img src="/assets/logo-federation.png" alt="Федерация киберспорта СКО" /><h1>ЖЕРЕБЬЁВКА DOTA 2</h1><p>{online ? 'Загружаем группы…' : 'Подключаемся к турниру…'}</p><small>Данные появятся после соединения с сервером.</small></div>}
      {operator && data && <DrawAdmin data={data} online={online} busy={busy} error={error} act={act} matches={built.matches} onClose={() => setAdminOpen(false)} />}
    </div>
    {built.error && <p className="draw-error" role="alert">Не удалось составить расписание: {built.error}</p>}
  </main>;
}
